import React, { FunctionComponent } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import EditButton from '../Button/EditButton';
import editButtonWithLabelStyles from './editButtonWithLabelStyles';
import useToggleFinCalcSpc from '../../../react/useToggleFinCalcSpc';
import Translation from '../../translation/Translation';

const EditButtonWithLabel: FunctionComponent = () => {
  const { toggleFinanceCalculatorSpc } = useToggleFinCalcSpc();
  const styles = editButtonWithLabelStyles();

  return (
    <Box display="flex" alignItems="center">
      <Typography className={styles.editLabel}>
        <Translation id="spc.configuratorSummary.sticky.edit" defaultMessage="Editar" />
      </Typography>
      <EditButton
        action={() => toggleFinanceCalculatorSpc(true)}
        border={true}
        size="small"
        className={styles.stickyEditButton}
        data-test="button:edit-calculation:edit"
      />
    </Box>
  );
};

export default EditButtonWithLabel;
